import {formatMoney} from '@shopify/theme-currency';

const selectors = {
  saleClass: 'on-sale',
  soldClass: 'sold-out',
};

export function formatPrices(product) {
  // Apprend classes for on sale and sold out
  const on_sale = product.price < product.compare_at_price_min;
  let classes = on_sale ? selectors.saleClass : '';
  classes += product.available ? '' : selectors.soldClass;
  // Add 'from' before min prive if price varies
  product.price = formatMoney(product.price, theme.moneyFormat);
  if (product.prive_varies) {
    let min = formatMoney(product.price_min, theme.moneyFormat);
    product.price = `${window.theme.strings.from} ${min}`;
  }

  const formatted = {
    ...product,
    classes,
    on_sale,
    sold_out: !product.available,
    sold_out_translation: window.theme.strings.sold,
    compare_at_price: formatMoney(product.compare_at_price_min, theme.moneyFormat),
    compare_at_price_max: formatMoney(product.compare_at_price_max, theme.moneyFormat),
    compare_at_price_min: formatMoney(product.compare_at_price_min, theme.moneyFormat),
    price_max: formatMoney(product.price_max, theme.moneyFormat),
    price_min: formatMoney(product.price_min, theme.moneyFormat),
  };
  return formatted;
}
